// frontend/src/pages/asset-admin/AssetAdminApiAccess.js
/**
 * Asset Admin – API Access
 *
 * Custodian-facing console for Service API Keys confined to the Assets & Fleet
 * scope domain (fleet vehicles, asset inventory, software licences). Custodians
 * can see, generate, rotate, disable and revoke these keys without the HR-admin
 * central console — and, by server-side allowlist, can never mint a key that
 * reaches phone / attendance / payroll data.
 *
 * Reuses the shared ServiceApiKeysTab console via an asset-scoped `apiBase`, so
 * this surface can never drift from the central one. HR-only "excluded PII
 * domains" guidance is suppressed here (those scopes aren't offered).
 *
 * Theme: Red (Admin)
 * @see frontend/src/styles/design-system-reference.md
 */

import React from 'react';
import { Key } from 'lucide-react';

import ServiceApiKeysTab from '../admin/ExternalTokens/ServiceApiKeysTab';

const ASSET_API_ACCESS_CONFIG = {
  apiBase: '/asset-inventory/service-api-keys',
  showExcludedInfo: false,
};

const AssetAdminApiAccess = () => {
  return (
    <div className="space-y-5">
      {/* Page header — matches the asset-admin page-header pattern */}
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-9 h-9 sm:w-10 sm:h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
          <Key className="w-4 h-4 sm:w-5 sm:h-5 text-red-600" />
        </div>
        <div className="min-w-0 flex-1">
          <h1 className="text-base sm:text-xl font-bold text-gray-900 truncate">API Access</h1>
          <p className="text-xs sm:text-sm text-gray-500">
            Service API keys for asset &amp; fleet data. External tools use these to read the register — scoped to assets only.
          </p>
        </div>
      </div>

      <ServiceApiKeysTab config={ASSET_API_ACCESS_CONFIG} />
    </div>
  );
};

export default AssetAdminApiAccess;
